export const ADD_TO_HOME_SCREEN_FROM_SETTINGS = 'ADD_TO_HOME_SCREEN_FROM_SETTINGS';
export const PWA_INSTALL_AVAILABLE = 'PWA_INSTALL_AVAILABLE';
export const PWA_INSTALLED = 'PWA_INSTALLED';
